import { getAPI } from "@/axios-api";



export async function fetchVisibleModules() {
  try {
    const response = await getAPI.get('modules/list_module_visible?page=1&page_size=20');
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching visible modules:', error);
    return [];
  }
}

/**
 * Fetch module statistics for a user
 * @param {string} userId - The user ID to fetch module statistics for
 * @returns {Promise<Object>} Module statistics data
 */
export async function fetchModuleStatistics(userId) {
  try {
    // Get user ID from parameter or fallback to localStorage
    const user = userId || localStorage.getItem('user');
    
    if (!user) {
      console.error('No user ID provided');
      return [];
    }
    
    const response = await getAPI.get(`stat_module/${user}/`);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching module statistics:', error);
    return [];
  }
}

/**
 * Check if all modules are completed by a user
 * @param {string} userId - The user ID to check module completion for
 * @returns {Promise<boolean>} True if all modules are completed, false otherwise
 */
export async function checkModulesCompletion(userId) {
  try {
    const visiblesModules = await  fetchVisibleModules()
    const statsModules = await fetchModuleStatistics(userId);
    
    if (visiblesModules?.count == statsModules.length && statsModules.length > 0) {
      return statsModules.every(item => item.progression >= 100);
    }
    return false;
  } catch (error) {
    console.error('Error checking module completion:', error);
    return false;
  }
}

/**
 * Fetch feedback questions from the API
 * @returns {Promise<Array>} Array of feedback questions
 */
export async function fetchFeedbackQuestions() {
  try {
    const response = await getAPI.get('/modules/feedback/questions');
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching feedback questions:', error);
    return [];
  }
}

/**
 * Submit feedback answers to the API
 * @param {Array} answers - Array of answers with question_id and choice_id
 * @returns {Promise<Object>} Response from the API
 */
export async function submitFeedbackAnswers(answers) {
  try {
    const response = await getAPI.post('/modules/feedback/submit/', answers);
    return response.data;
  } catch (error) {
    console.error('Error submitting feedback answers:', error);
    throw error;
  }
}